import { useEffect, useState } from 'react';

export interface LeaderboardRow {
  key: string;
  profileId: string | null;
  name: string;
  emoji: string | null;
  avatar: string | null;
  gamesPlayed: number;
  gamesWon: number;
  winPct: number;
  avgFinalScore: number;
  bestFinalScore: number | null;
  roundsScored: number;
  exact: number;
  exactPct: number;
  overUnderIndex: number;
}

type State =
  | { status: 'loading' }
  | { status: 'ready'; rows: LeaderboardRow[] }
  /** Offline or the server is unreachable — not an error worth shouting about. */
  | { status: 'unavailable' };

export function useLeaderboard(): State {
  const [state, setState] = useState<State>({ status: 'loading' });

  useEffect(() => {
    let cancelled = false;

    fetch('/api/stats/leaderboard')
      .then((response) => {
        if (!response.ok) throw new Error(String(response.status));
        return response.json() as Promise<LeaderboardRow[]>;
      })
      .then((rows) => {
        if (!cancelled) setState({ status: 'ready', rows });
      })
      .catch(() => {
        if (!cancelled) setState({ status: 'unavailable' });
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
